<template>
    <Main>
        <el-row :gutter="20" class="search-table">
            <el-col :span="14" :xs="24" class="mb-2 mb-sm-0">
                <InputSearch v-model="keySearch" @keydown.enter="handleSearchData" @search="handleSearchData" :placeholder="$t('share.searchPlaceholder')"></InputSearch>
            </el-col>
            <el-col :span="5" :xs="24" class="mb-2 mb-sm-0">
                <SelectCustom v-model="config.dataFilter['user_share']" :placeholder="$t('member.fullName')">
                    <template #options>
                        <el-option-group v-for="(company, indexC) in listMembers" :key="indexC + 'index'" :label="company.company">
                            <el-option v-for="user in company.options" :key="user.id" :label="`${user.surname} ${user.name}`" :value="user.id"> </el-option>
                        </el-option-group>
                    </template>
                </SelectCustom>
            </el-col>
            <InputNotes v-if="isViewDataLinkMulti"></InputNotes>
        </el-row>
        <el-row :gutter="20" class="mt-2 mt-sm-3">
            <el-col :span="7" :xs="24" class="mb-sm-0 mb-2">
                <DateTimePicker
                    :date-time.sync="dateTime"
                    :placeholder-start="$t('msgCommon.placeholderCreatedAtStart')"
                    :placeholder-finish="$t('msgCommon.placeholderCreatedAtEnd')"
                ></DateTimePicker>
            </el-col>
            <el-col :span="7" :xs="24">
                <DateTimePicker
                    id-string="dateTimeUpdate"
                    id="dateTimeUpdate"
                    :date-time.sync="dateTimeUpdate"
                    :placeholder-start="$t('member.datePickerStartPlaceholder')"
                    :placeholder-finish="$t('member.datePickerEndPlaceholder')"
                ></DateTimePicker>
            </el-col>
        </el-row>
        <TableBox :config="config" :reload="isReload" :data-list.sync="dataList" @updateModel="updateModel" class="table-list-share">
            <template #row="{ row, index, page, perPage }">
                <tr :class="{ 'row-disabled': !row.enable }">
                    <td :data-title="$t('textCommon.no')">
                        <div class="col-first">
                            {{ index + 1 + (page - 1) * perPage }}
                        </div>
                    </td>
                    <td class="col-share-name" :data-title="$t('member.shareName')">
                        <div class="col-share-name__text">{{ row['link_name'] }}</div>
                    </td>
                    <td class="col-full-name" :data-title="$t('share.fullName')">{{ row['user_share'] && row['user_share'].surname }} {{ row['user_share'] && row['user_share'].name }}</td>
                    <td class="col-company" :data-title="$t('member.company')">
                        {{ row['user_share'] && row['user_share']['company_name'] }}
                    </td>
                    <td class="col-email" :data-title="$t('share.email')">
                        {{ row['user_share'] && row['user_share'].email }}
                    </td>
                    <td class="col-space" :data-title="$t('share.app')">
                        {{ row['app_name'] || '' }}
                    </td>
                    <td class="col-space" :data-title="$t('share.view')">
                        {{ row['view_name'] || '' }}
                    </td>
                    <td class="col-filter" :data-title="$t('share.filterData')">
                        <div>
                            <div v-for="(item, indexF) in getFilters(row)" :key="indexF" class="filter-content" v-html="item"></div>
                        </div>
                    </td>
                    <td class="text-left text-sm-center col-created" :data-title="$t('member.updated_at')">
                        <FormatDate format="YYYY/MM/DD HH:mm:DD" :date="row.updated_at"></FormatDate>
                    </td>
                    <td class="text-left text-sm-center col-created" :data-title="$t('member.created_at')">
                        <FormatDate format="YYYY/MM/DD HH:mm:DD" :date="row.created_at"></FormatDate>
                    </td>
                    <div class="d-flex justify-content-around flex-wrap fixed-right">
                        <Button classes="btn-xs mr-2 " type="outline-primary" :disabled="!row.enable" @click="handleViewData(row)">
                            <el-icon class="el-icon-document"></el-icon>
                            {{ $t('button.detail') }}
                        </Button>
                        <Button classes="btn-xs mr-2 " type="info" v-if="isAccountAdmin" :disabled="!row.enable" @click="handleGoEdit(row)">
                            <el-icon class="el-icon-edit"></el-icon>
                            {{ $t('button.edit') }}
                        </Button>
                        <Button :disabled="isLoading" classes="btn-xs mr-2 " type="warning" v-if="isAccountAdmin" @click="changeStatusConfirm(row)">
                            <el-icon class="el-icon-set-up"></el-icon>
                            {{ !row.enable ? $t('button.active') : $t('button.deactive') }}
                        </Button>
                        <Button classes="btn-xs mr-2 " :disabled="isLoading" @click="handleDeleteConfirm(row)" v-if="isAccountAdmin" type="danger">
                            <el-icon class="el-icon-delete"></el-icon>
                            {{ $t('button.delete') }}
                        </Button>
                    </div>
                    <td :data-title="''" class="col-action col-action__middle text-sm-center text-left fix-right_mb" :class="{ 'col-action__large': isAccountAdmin }">
                        <div class="d-flex justify-content-around flex-wrap">
                            <Button classes="btn-xs px-2 mr-2 mr-sm-0" type="outline-primary" :disabled="!row.enable" @click="handleViewData(row)">
                                <el-icon class="el-icon-document"></el-icon>
                                {{ $t('button.detail') }}
                            </Button>
                            <Button classes="btn-xs px-2 mr-2 mr-sm-0" type="info" v-if="isAccountAdmin" :disabled="!row.enable" @click="handleGoEdit(row)">
                                <el-icon class="el-icon-edit"></el-icon>
                                {{ $t('button.edit') }}
                            </Button>
                            <Button :disabled="isLoading" classes="btn-xs px-2 mr-2 mr-sm-0" type="warning" v-if="isAccountAdmin" @click="changeStatusConfirm(row)">
                                <el-icon class="el-icon-set-up"></el-icon>
                                {{ !row.enable ? $t('button.active') : $t('button.deactive') }}
                            </Button>
                            <Button classes="btn-xs px-2 mr-2 mr-sm-0" :disabled="isLoading" @click="handleDeleteConfirm(row)" v-if="isAccountAdmin" type="danger">
                                <el-icon class="el-icon-delete"></el-icon>
                                {{ $t('button.delete') }}
                            </Button>
                        </div>
                    </td>
                </tr>
            </template>
        </TableBox>
    </Main>
</template>

<script>
import Main from '@/components/partials/layout/Main';
import TableBox from '@/components/partials/layout/TableBox';
import InputSearch from '@/components/partials/customs/InputSearch';
import InputNotes from './components/InputNotes.vue'
import DateTimePicker from '@/components/partials/customs/DateTimePicker';
import Button from '@/components/partials/Button';
import { mapState } from 'vuex';
import FormatDate from '@/components/partials/FormatDate';
import SelectCustom from '@/components/partials/customs/SelectCustom';
import { groupByData } from '@/utils';

export default {
    name: 'ShareList',
    components: {
        FormatDate,
        TableBox,
        Main,
        InputSearch,
        DateTimePicker,
        Button,
        SelectCustom,
        InputNotes
    },
    data: function () {
        return {
            config: {
                q: '',
                action: 'connect/get_list_user_connect',
                headers: [
                    {
                        label: 'textCommon.no'
                    },
                    {
                        sort: 'link_name',
                        label: 'share.shareName'
                    },
                    {
                        label: 'share.fullName'
                    },
                    {
                        sort: 'company_share',
                        label: 'member.company'
                    },
                    {
                        sort: 'email_share',
                        label: 'share.email'
                    },
                    {
                        sort: 'app_name',
                        label: 'share.app'
                    },
                    {
                        label: 'share.view'
                    },
                    {
                        label: 'share.filterData'
                    },
                    {
                        sort: 'updated_at',
                        label: 'member.updated_at'
                    },
                    {
                        sort: 'created_at',
                        label: 'member.created_at'
                    },
                    {
                        label: ''
                    }
                ],
                value: [1, 0],
                dataFilter: {
                    user_share: '',
                    start_updated_at: '',
                    end_updated_at: '',
                    start_created_at: '',
                    end_created_at: ''
                },
                dataLinkMultiId: this.$route.query.id ?? null,
                sort: {
                    field: 'updated_at',
                    order: 'desc'
                }
            },
            isReload: false,
            keySearch: null,
            isLoading: false,
            dataList: [],
            dateTime: [],
            dateTimeUpdate: [],
            listMembers: []
        };
    },
    mounted() {
        if (this.isAccountAdmin) {
            this.getListAllMember();
        }
    },
    watch: {
        dateTime: {
            deep: true,
            handler: function (val) {
                this.config.dataFilter.start_created_at = val ? val[0] : '';
                this.config.dataFilter.end_created_at = val ? val[1] : '';
            }
        },
        dateTimeUpdate: {
            deep: true,
            handler: function (val) {
                this.config.dataFilter.start_updated_at = val ? val[0] : '';
                this.config.dataFilter.end_updated_at = val ? val[1] : '';
            }
        },
        isAccountAdmin: {
            deep: true,
            handler: function (val) {
                if (val) {
                    this.getListAllMember();
                }
            }
        }
    },
    computed: {
        ...mapState('auth', ['userInfo']),
        isViewDataLinkMulti() {
          return this.$route.name === 'viewDataLinkMulti'
        },
        isAccountAdmin() {
            let userRole = this.userInfo.type;
            return userRole === 2;
        }
    },
    methods: {
        getFilters(row) {
            let result = [];
            if (row && row['array_filter']) {
                if (row['array_filter'].length > 0) {
                    if (row['data_filter']) {
                        let query = row['array_filter'][0].query ? row['array_filter'][0].query : '';
                        let typeFilter = row['data_filter'].includes(' or ') ? ' or ' : ' and ';
                        let arrayData = query.split(typeFilter);

                        if (arrayData && arrayData.length > 0) {
                            arrayData.map((elm, index) => {
                                if (index < arrayData.length - 1) {
                                    result.push(elm + `<strong>${typeFilter}</strong>`);
                                } else {
                                    result.push(elm);
                                }
                            });
                        }
                    } else {
                        result.push(this.$t('filter.allRecord'));
                    }
                } else {
                    result.push(this.$t('filter.allRecord'));
                }
            }
            return result;
        },
        handleGoEdit(row) {
            this.$router.push({
                name: 'editShare',
                query: {
                    id: row.id,
                    idUser: row['user_share'] ? row['user_share'].id : null,
                    typeShare: 'form-filter'
                }
            });
        },
        handleViewData(row) {
            if (this.$router.currentRoute.name === 'viewDataLinkMulti') {
                this.$router.push({
                    name: 'dataLinkMultiDataView',
                    query: {
                        id: row.id,
                        idDataLink: this.$route.query.id
                    }
                });
            } else {
                this.$router.push({
                    name: 'dataView',
                    query: { id: row.id }
                });
            }
        },
        changeStatusConfirm(row) {
            this.$store.commit('noticeSystem/SET_CONFIRM', {
                type: `warning`,
                isShowConfirm: true,
                message: !row.enable ? this.$t('share.msgActiveShareConfirm') : this.$t('share.msgDeActiveShareConfirm'),
                callback: () => {
                    this.changStatusCallback(row);
                }
            });
        },

        changStatusCallback(row) {
            if (this.isLoading) return;
            this.isLoading = true;
            let successCallback = (response) => {
                this.isReload = !this.isReload;
                let message = !row.enable ? this.$t('share.msgActiveShareSuccess') : this.$t('share.msgDeactiveShareSuccess');
                this.$store.commit('noticeSystem/SET_MESSAGE', {
                    isShowMessage: true,
                    type: 'success',
                    message: message
                });
                this.isLoading = false;
            };
            let errorCallback = () => {
                this.isLoading = false;
                this.isReload = !this.isReload;
            };
            let payload = {
                successCallback,
                errorCallback,
                data: {
                    status: !row.enable
                },
                id: row.id
            };
            this.$store.dispatch('connect/change_status_user_connect', payload);
        },
        handleDeleteConfirm(row) {
            this.$store.commit('noticeSystem/SET_CONFIRM', {
                type: `warning`,
                isShowConfirm: true,
                message: this.$t('share.msgDeleteShareConfirm'),
                callback: () => {
                    this.deleteCallback(row);
                }
            });
        },

        deleteCallback(row) {
            if (this.isLoading) return;
            this.isLoading = true;
            let successCallback = (response) => {
                if (response.status === 200) {
                    this.isReload = !this.isReload;
                    this.$store.commit('noticeSystem/SET_MESSAGE', {
                        isShowMessage: true,
                        type: 'success',
                        message: this.$t('share.msgDeleteShareSuccess')
                    });
                }
                this.isLoading = false;
            };
            let errorCallback = () => {
                this.isReload = !this.isReload;
                this.isLoading = false;
            };
            let payload = {
                successCallback,
                errorCallback,
                id: row.id
            };
            this.$store.dispatch('connect/delete_user_connect', payload);
        },

        getListAllMember() {
            let successCallback = (response) => {
                if (response.status) {
                    let { data } = response.data;
                    let listMemberGet = data.data_list || [];
                    listMemberGet = listMemberGet.filter((elm) => elm['parent_id']);
                    let listMemberByGroup = groupByData(listMemberGet, 'company_name');
                    this.listMembers = [];
                    if (listMemberByGroup) {
                        Object.keys(listMemberByGroup).map((key) => {
                            let item = {
                                company: key,
                                options: listMemberByGroup[key]
                            };
                            this.listMembers.push(item);
                        });
                    }
                }
            };
            let errorCallback = () => {};
            let payload = {
                successCallback,
                errorCallback
            };
            this.$store.dispatch('member/getListAllMembers', payload);
        },
        handleSearchData() {
            this.config.q = this.keySearch ? this.keySearch.toString().trim() : '';
            this.config = Object.assign({}, this.config);
        },
        updateModel(e) {
            this.config.dataFilter = Object.assign({}, e.dataFilter);
            this.dateTime[0] = e.dataFilter.start_created_at || '';
            this.dateTime[1] = e.dataFilter.end_created_at || '';
            this.dateTimeUpdate[0] = e.dataFilter.start_updated_at;
            this.dateTimeUpdate[1] = e.dataFilter.end_updated_at;
            this.config.q = e.search;
            this.keySearch = e.search;
        }
    }
};
</script>
